import { AssessmentType } from '../types';
import { createStandardAction } from 'typesafe-actions';

export const setAssessmentsData = createStandardAction(
  'ASSESSMENT/SET_DATA'
)<AssessmentType>();
